import {Page, Text, View, Document, StyleSheet, Image, Font } from '@react-pdf/renderer';

//import sansFont from "../../assets/fonts/OpenSans-Regular.ttf"
import sansFont from "../../assets/fonts/OpenSans-Bold.ttf"

Font.register({ 
    family: "Sans", 
    format: "truetype",
    src: sansFont
});

const styles = StyleSheet.create({
    page: {
      backgroundColor: '#FFFFFF',
      flexDirection: 'column',
      marginTop:10,
      marginLeft:10,
      paddingTop: 5,
      paddingRight:20
    },
    heading:{
        flexDirection: 'row',
    },
    section: {
    //   margin: 10,
    //   padding: 10,
      marginTop: 5,
      flexGrow: 1,

    },
    image:{
        height: 29,
        width:120
    },
    department:{
        fontFamily:'Times-Roman',
        fontSize: 25,
        marginLeft:0,
        opacity: 0.75
    },
    departmentMargin:{
        fontFamily:'Times-Roman',
        marginLeft: 60,
        marginTop:10,
        opacity: 0.75,
        fontSize: 25
    },
    address:{
        marginLeft: 43,
        fontSize: 12,
    },

    information:{
        fontFamily:'Times-Roman',
        fontSize: 11,
        opacity: 0.75,
        marginRight: 20,
        padding: 10
    },

    company: {
        fontFamily:'Times-Roman',
        height: 10
    },

    textPadding:{
        paddingBottom:4,
        paddingRight:0
    },
    envProtectionImage:{
        height: 45,
        width: 50,
        marginLeft: 30
    },
    miniStamp:{
        alignItems:'flex-end',
        marginRight:5,
    },
    stateofFLMS:{
        fontSize: 8,
        fontFamily:'Sans',
        opacity:0.75,
        marginLeft: 33
    },
    departmentMS:{
        fontSize: 8,
        fontFamily:'Sans',
        opacity:0.75,
        marginLeft: 30
    },
    envMs:{
        fontSize: 8,
        fontFamily:'Sans',
        opacity:0.75
    },
    alignImageMS:{
        flexDirection:'row',
        marginLeft: 20
    },
    certificateMS:{
        fontSize:8,
        marginTop:2,
        fontFamily:'Times-Roman',
        marginLeft:10
        // paddingTop:15
    },
    certificateFrame: {
        position: 'absolute',
        // minWidth: '100%',
        // minHeight: '100%',
        display: 'block',
        height: 380,
        width: 590,
      },
      frame:{
        // margin: 20,
        // border: '20px solid rgba(1, 53, 60, 1)',
        height:"50%",
        marginLeft: 0,
        marginTop:0
      },
      textAbs:{
        position:'absolute'
      },
      textFrame:{

        fontSize: 12,
        fontFamily:'Times-Roman',
        opacity:0.75,
        
    },
    frameImage:{
        height: 29,
        width:120,
        marginTop: 15,
        marginRight: 70
    },
    frameEnvProtectionImage:{
        height: 45,
        width:50,
        // marginRight: 40
    },
    frameDepartmentMargin:{
        fontFamily:'Times-Bold',
        marginLeft: 15,
        opacity: 0.7,
        fontSize:15
    },
    frameDepartment:{
        fontFamily:'Times-Bold',
        fontSize: 19,
        marginLeft:7,
        opacity: 0.7,
        marginTop:5,
        marginBottom:5
    },
    fontInCertificate:{
        fontFamily:'Times-Roman',
        fontSize: 12,
    },
    centerTextFrame:{
        display: "flex",
        alignItems: "center",
        justifyContent:'space-around',
        height: 150
    },
    inFramePhotoLite: {
        position: 'absolute',
        display: 'block',
        height: 253,
        width: 280.5,
        top: '1px',
        // opacity: 0.1,
        left: '-1px'
      },
    frameHeading:{
        margin: 25,
        display:'flex',
        flexDirection: 'row',
    },
    signaturesStyle:{
        display: "flex",
        flexDirection:"row",
        fontSize: 9,
        fontFamily:'Times-Roman',
        marginLeft: 35,
        marginBottom: 45,
        width: 520,
        justifyContent:'space-between'
    },
    signatureAlignment:{
        display:'flex',
        flexDirection:'column',
        // margin:10,
        alignItems:'center',
        // justifyContent:'center'
        marginBottom: 10
    },
    lineNumber:{
        borderBottom: '1px solid black',
        width: 70

    },
    gibvmp:{
        marginRight:22,
        fontSize: 8,
        fontFamily:'Sans',
        opacity:0.75
    },
    envProtectionImageLite:{
        position: 'absolute',
        height: 70,
        width: 77.5,
        marginLeft:10,
        marginBottom: 20,
    },
    sign:{
        height:30,
        width: 60
    },
    imageUF:{
        height: 20,
        width:130
    }
  });

function Certificate(props){

    console.log('props', props)

    return(
        <Document title="GI-BMP Certificate" author="GI-BMP system" subject={props.name}>
                <Page size="LETTER" style={styles.page} >
                    <View style={styles.heading} >
                        <View style={{...styles.section, marginTop: 20, marginLeft: 10}}>
                            <Image style={styles.imageUF} src={require("../../assets/certificateImages/ifas_newv2.png")} />
                        </View>
                        <View style={styles.section}>
                            <View style={styles.departmentMargin}>
                                <Text>Department of</Text>
                            </View>
                            <View style={styles.department}>
                                <Text>Environmental Protection</Text>
                            </View>
                            <View style={styles.address}>
                                <Text>2600 Blair Stone Road, M.S. 3510</Text>
                            </View>
                            <View style={styles.address}>
                                <Text>Tallahassee, Florida 32399-2400</Text>
                            </View>
                            
                        </View>
                        <View style={{...styles.section, left: 10, marginTop: 20}}>
                            <Image style={styles.image} src={require("../../assets/certificateImages/ffl_v2.png")} />
                            <Image style={{...styles.envProtectionImage, marginleft:20}} src={require("../../assets/certificateImages/DEP-logo-2023.png")} />
                        </View>
                    </View>
                    <View style={styles.information}>
                               
                        <View
                        style={{
                            display: 'flex',
                            flexDirection: 'row',
                            flexWrap: 'wrap',
                            position: 'relative',
                            paddingBottom:4
                        }}
                        >
                            <View>
                                <Text style={{  }}>Congratulations on successfully completing the Florida Green Industries Best Management Practices Training. Your certificate and wallet card are below. If the certificate is not correct, please contact the GI-BMP office of the UF/IFAS Florida-Friendly </Text>
                            </View>
                            <View>
                                <Text style={{  }}>Landscaping</Text>
                            </View>
                            <View>
                                <Text style={{ fontSize: 4 }}>TM </Text>
                            </View>
                            <View>
                                <Text style={{  }}>Program at gi.bmp@ifas.ufl.edu or (352) 273-4517.</Text>
                            </View>
                        </View>

                        <Text style={styles.textPadding}>To legally apply fertilizer commercially in Florida, you need the Limited Urban Commercial Fertilizer Applicator Certification from Florida Department of Agriculture and Consumer Services (FDACS). Use the certificate # below to apply online: https://aeslicensing.fdacs.gov  For help:  FDACS Pest Control Licensing and Certification (850) 617-7997</Text>
                        <Text>If your GI-BMP test score is 90% or higher, you may be eligible to become a GI-BMP Instructor.</Text>
                        <Text>Learn more at https://ffl.ifas.ufl.edu/ffl-and-you/gi-bmp-program/instructor-program/</Text>
                    </View>
                    
                    <View style={styles.company}>
                            <View style={{ position:'absolute', top: '60px', left: '60px' }}  >
                                <Text style={{fontSize: 12}}> {props.name} </Text>
                                <Text style={{fontSize: 12}}> {props.companyName ? props.companyName : ''} </Text>
                            </View>
                    </View>

                    <View style={styles.miniStamp} >
                       
                        <View style={{alignItems:'flex-end', position:'absolute', top:'-35px', paddingRight: (props.traineeID === '' && props.certDate === '' && props.testScore === '') ? '60' : '0'}} >
                            <Text style={{fontSize: 10}} >GI-BMP Certificate #: {props.certID}</Text>
                            <Text style={{fontSize: 10}}>Certification Date: {props.certDate}</Text>
                            <Text style={{fontSize: 10}}>Test Score: {props.testScore}</Text>
                        </View>
                        <View style={{borderLeft: '1px dotted black',borderTop: '1px dotted black', marginRight: 0}}>
                            <View style={{ marginLeft: 55, marginTop:8}}>
                                <Text style={styles.stateofFLMS}> State of Florida</Text>
                                <Text style={styles.departmentMS}> DEPARTMENT OF</Text>
                                <Text style={styles.envMs}> ENVIRONMENTAL PROTECTION</Text>
                            </View>
                            {
                                console.log('length', props.name.length)
                            }
                            <View>
                                <Text style={{fontSize: 14, fontFamily:'Times-Bold', 
                                // left: props.name.length > 15 ? (props.name.length > 22 ? (props.name.length > 27 ? 10 : 40) : 60 ): props.name.length > 10 ? 80 : 90  , 
                                top: 20, position: 'absolute', width: 240, textAlign:'center'  }}  > 
                                        {props.name} 
                                </Text>
                            </View>
                            <View style={styles.alignImageMS} >
                                <View style={{ marginTop: 40, alignContent:'center' }}>
                                    <View style={{ fontSize: 8, marginTop:3, textAlign:'center', alignContent:'center', marginBottom:2, marginLeft:4 }} ><Text>{props.certID}</Text></View>
                                    <View style={{...styles.lineNumber, width: 50}}></View>
                                    <Text style={{...styles.certificateMS, marginLeft:5}}>Certificate #</Text>
                                </View>
                                <View>
                                    <Image style={styles.envProtectionImageLite} src={require("../../assets/certificateImages/lite_env_protect.png")} />
                                </View>
                            
                                <View style={{ marginTop: 40, alignContent:'center', marginLeft: 100 }}>
                                    <View style={{ fontSize: 8, marginTop:3, textAlign:'center', alignContent:'center', marginBottom:2, marginLeft:4 }} ><Text>{props.traineeID}</Text></View>
                                    <View style={{...styles.lineNumber, width: 45}}></View>
                                    <Text style={{...styles.certificateMS, marginLeft:3}}>Trainee ID #</Text>
                                </View>
                            </View>
                            <Text style={{...styles.gibvmp, marginLeft: 15, marginTop: 7}}> GREEN INDUSTRIES BEST MANAGEMENT PRACTICES</Text>
                            <Text style={{...styles.gibvmp, marginLeft: 80, marginBottom: 7}}> TRAINING PROGRAM</Text>
                        </View>
                        
                    </View>

                    <View style={{  borderBottom: '1px dotted black', marginBottom: 10}} ></View>

                    <View style={styles.frame} 
                    // debug='true'
                    >
                        <Image src={require("../../assets/certificateImages/frame.jpg")} style={styles.certificateFrame}  />
                        <View style={styles.frameHeading}  >
                            <View style={styles.section}>
                                <View>
                                    <Image style={{...styles.frameImage, paddingLeft:15,  height: 15}} src={require("../../assets/certificateImages/ifas_newv2.png")} />
                                    <View style={{...styles.certificateMS, paddingLeft: 12, fontSize: 10, paddingTop: props.certID === '' ? 10 : 0 }}>
                                        <View style={{ fontSize: 8, marginTop:3, textAlign:'center', alignContent:'center', marginBottom:2, marginLeft:4 }} ><Text>{props.certID}</Text></View>
                                        <View style={{...styles.lineNumber, width: 50}}></View>
                                        <Text style={{...styles.certificateMS, marginLeft:0}} >Certificate #</Text>
                                    </View>
                                    <View style={{...styles.certificateMS, paddingLeft:12, fontSize: 10 , paddingTop: props.certID === '' ? 10 : 0}}>
                                        <View style={{ fontSize: 8, marginTop:3, textAlign:'center', alignContent:'center', marginBottom:2, marginLeft:4 }} ><Text>{props.traineeID}</Text></View>
                                        <View style={{...styles.lineNumber, width: 45}}></View>
                                        <Text style={{...styles.certificateMS, marginLeft:0}}>Trainee ID #</Text>
                                    </View>
                                </View>
                                
                            </View>
                            <View style={{...styles.section}} >
                                <Image src={require("../../assets/certificateImages/watermark_v2.png")} style={styles.inFramePhotoLite} />
                                <View style={{ display: 'flex', justifyContent:'center', alignContent:'center', alignItems:'center', marginTop:30}}>
                                    <View style={{...styles.frameDepartmentMargin, marginRight: 6}}>
                                        <Text>Certificate of Training</Text>
                                    </View>
                                    <View style={styles.frameDepartment}>
                                        <Text>Best Management Practices</Text>
                                    </View>
                                    <View style={{...styles.frameDepartmentMargin, marginRight: 6}}>
                                        <Text>Florida Green Industries</Text>
                                    </View>
                                </View>
                                
                                <View style={styles.centerTextFrame}>
                                    <View>
                                        <Text style={{...styles.fontInCertificate,  marginLeft:7,  paddingTop: 0}}>The undersigned hereby acknowledges that</Text>
                                    </View>
                                    <View>
                                        <Text style={{paddingRight: 10, fontFamily: 'Times-Roman', fontSize: 25, position: 'absolute', width: 600, left: -290, textAlign:'center'  }} >{props.name}</Text>
                                    </View>
                                    <View 
                                    style={{left: -55, top: 20 }} 
                                    >
                                        <Text style={styles.fontInCertificate} >has successfully completed the Green Industries Best Management Practices Program</Text>
                                        <Text style={{...styles.fontInCertificate, paddingLeft: 10}} > developed by the Florida Department of Environmental Protection with the</Text>
                                        <Text style={{...styles.fontInCertificate, paddingLeft: 30}} > University of Florida Institute of Food and Agricultural Sciences.</Text>
                                    </View>
                                </View>
                                
                               
                            </View>
                            <View style={{...styles.section, marginRight: 25}}>
                                <Image style={{...styles.frameImage}} src={require("../../assets/certificateImages/ffl_v2.png")} />
                                <Image 
                                style={{...styles.frameEnvProtectionImage, marginTop: 10, marginLeft: 30}} 
                                src={require("../../assets/certificateImages/DEP-logo-2023.png")} />
                            </View>
                        </View>
                        <View 
                        style={styles.signaturesStyle} 
                        // debug='true'
                        >
                                    <View style={{...styles.signatureAlignment, fontSize: 8}}>
                                        <Image style={styles.sign} src={require("../../assets/certificateImages/sign_1_newDesign.png")} />
                                        <View style={{...styles.lineNumber, width: 100}}></View>
                                        <Text>Tom Wichman</Text>
                                         <View
                                            style={{
                                                display: 'flex',
                                                flexDirection: 'row',
                                                flexWrap: 'wrap',
                                                position: 'relative',
                                            }}
                                            >
                                            <View>
                                                <Text style={{  }}>Assistant Director </Text>
                                            </View>
                                            <View>
                                                <Text style={{  }}>Florida-Friendly Landscaping</Text>
                                            </View>
                                            <View>
                                                <Text style={{ fontSize: 4 }}>TM </Text>
                                            </View>
                                            <View>
                                                <Text style={{  }}>Program</Text>
                                            </View>
                                        </View>
                                    </View>
                                    <View style={{ ...styles.signatureAlignment, fontSize: 8, paddingTop:20}}>
                                        <Text>{props.instructor ? props.instructor: ' '}</Text>
                                        <View style={{...styles.lineNumber, width: 70}}></View>
                                        <Text>Instructor</Text>
                                        <Text></Text>
                                    </View>
                                    <View style={{ ...styles.signatureAlignment, fontSize: 8, paddingTop: props.certDate === '' ? 29 : 20 }}>
                                        <Text>{props.certDate}</Text>
                                        <View style={{...styles.lineNumber, width: 50}}></View>
                                        <Text>Date</Text>
                                        <Text></Text>
                                    </View>
                                    <View style={{...styles.signatureAlignment, fontSize: 8, paddingBottom:2 }}>
                                        <Image 
                                        style={styles.sign} 
                                        src={require("../../assets/certificateImages/sign_3.png")}  
                                        />
                                        <View style={{...styles.lineNumber, width: 150}}></View>
                                        <Text>Claire Lewis, MLA</Text>

                                        <View
                                            style={{
                                                display: 'flex',
                                                flexDirection: 'row',
                                                flexWrap: 'wrap',
                                                position: 'relative',
                                            }}
                                            >
                                                <View>
                                                    <Text style={{  }}>Director Florida-Friendly Landscaping</Text>
                                                </View>
                                                <View>
                                                    <Text style={{ fontSize: 4 }}>TM </Text>
                                                </View>
                                                <View>
                                                    <Text style={{  }}>Program</Text>
                                                </View>
                                        </View>
                                    </View>
                                </View>
                    </View>
                   
                </Page>
            </Document>
    )
}

export default Certificate;